export default __webpack_public_path__ + "static/media/recruitment-active.4a95a025.svg";